import {Component, Input} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BacklogService} from "../../../../core/services/backlog.service";
import {GeneralService} from "../../../../core/services/general.service";
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";

@Component({
  selector: 'app-address',
  standalone: true,
    imports: [
        FormsModule,
        NgForOf,
        CommonSvgIconsComponent,
        NgStyle,
        NgIf
    ],
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss'
})
export class AddressComponent {
    @Input() confirmAction!: (data: any) => void;
    @Input() data: any;
    @Input() title: any;

    public address: any = {};
    constructor(public modalAddress :NgbModal, private backlogService: BacklogService, private generalService:GeneralService){

    }

    ngOnInit(): void {
        this.getAddress();
    }

    getAddress(){
        this.backlogService.getAddress(this.data).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    this.address = res.data;
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        );
    }
}
